import {
  Component,
  HostBinding,
  Input,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { SideMenusService } from '../side-menus/side-menus.service';
import { TourStep, TourService } from 'src/app/authentication/tour.service';
import { ModelSelectionService } from '../../services/model-selection.service';
import { AiCatalogComponent } from '../../authentication/dialogs/ai-catalog/ai-catalog.component';
import { ChatFireService } from '../../gen2ai/chatfire.service';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./styles/top-navbar.component.scss']
})
export class TopNavbarComponent implements OnInit, OnDestroy {
  @ViewChild('profileMenu') profileMenuRef!: ElementRef;
  @ViewChild('clarichatToolsMenuContainer') clarichatToolsMenuContainer?: ElementRef<HTMLDivElement>;

  get isTourButtonEnabled(): boolean {
    const allowedRoutes = ['/ai/clarity','ai/clarichat', '/ai/double-chat'];
    return allowedRoutes.some(route => this.router.url.includes(route));
  }

  menuOpen = false;
  gay = false;
  bigAL = false;
  private menuStateSubscription?: Subscription;

  _mode = 'expanded';
  isInDoubleSandbox = false;
  isInClarityChat = true;
  isInClarityVideoChat = false;
  isInClariAuth = true;

  isOnClariVideoRoute = false;
  public isOnCompareModeRoute = false;
  isOnClariChatRoute = false;
  isOnCloneRoute = false;
  isOnParallaxChatRoute = false;
  isOnMultiChatRoute = false;

  public showModelName = false;
  public showModelName2 = false;
  compareLeftName = '';
  compareRightName = '';
  compareLeftLetters: string[] = [];
  compareRightLetters: string[] = [];

  shortClariLetters = ['C', 'l', 'a', 'r', 'i', 't', 'y'];
  clariLetters = ['C', 'l', 'a', 'r', 'i', 'C', 'h', 'a', 't'];
  brandLetters = ['C', 'l', 'a', 'r', 'i', 'C', 'h', 'a', 't'];
  executiveLetters = ['E', 'x', 'e', 'c', 'u', 't', 'i', 'v', 'e', 'C', 'h', 'a', 't'];
  doubleChatLetters = ['D', 'o', 'u', 'b', 'l', 'e', 'C', 'h', 'a', 't'];
  parallaxLetters = ['P', 'a', 'r', 'a', 'l', 'l', 'a', 'x', ' ', 'C', 'h', 'a', 't'];
  fullClariLetters = ['C', 'l', 'a', 'r', 't', 'i', 'y'];
  private readonly clariBaseColor = { r: 192, g: 0, b: 0 };
  chatLetters = ['C', 'h', 'a', 't'];
  private readonly chatBaseColor = { r: 111, g: 198, b: 198 };
  private readonly chatDarkenStep = 12;
  private readonly modelNameWordSeparator = '\u00A0';
  private modelNameSub?: Subscription;

  isNavCollapsed = true;

  get isUserLoggedIn(): boolean {
    return this.isLoggedIn;
  }

  get isUserLoggedOut(): boolean {
    return !this.isLoggedIn;
  }

  private tourSub?: Subscription;
  private loginStateSub?: Subscription;
  private logoutSub?: Subscription;
  private modelChangeSub?: Subscription;

  isLoggedIn = false;
  selectedModelName = '';
  isTourActive = false;
  modelNameLetters: string[] = [];

  settingsMenuOpen = false;
  isScrolled = false;
  isTempChatActive = false;

  currentModelId = '';
  showToolsMenu = false;

  private guestTourStarted = false;

  private handleModelChange?: (event: CustomEvent) => void;
  private handleToolsMenuOpen?: () => void;
  private compareModelsChangedListener?: EventListener;
  private modelStoragePollInterval?: ReturnType<typeof setInterval>;
  readonly authState$: Observable<boolean>;

  @HostBinding('attr.mode')
  @Input()
  set mode(val: string) {
    this._mode = val ?? 'expanded';
  }
  get mode(): string {
    return this._mode;
  }

  constructor(
    private sideMenusService: SideMenusService,
    private router: Router,
    private dialog: MatDialog,
    private tourService: TourService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private modelSelectionService: ModelSelectionService,
    private chatFireService: ChatFireService
  ) {
    this.authState$ = this.chatFireService.authState$;
    const currentUrl = this.router.url;
    this.updateRouteFlags(currentUrl);
  }

  ngOnInit(): void {
    this.isTempChatActive = localStorage.getItem('tempChatActive') === 'true';
    this.syncCurrentModelId();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        const navEvent = event as NavigationEnd;
        this.updateRouteFlags(navEvent.urlAfterRedirects);
        this.readTopnavFlags();
        this.syncCurrentModelId();
      });

    this.loginStateSub = this.chatFireService.authState$.subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
      this.settingsMenuOpen = false;
      this.cdr.markForCheck();
    });

    this.tourSub = this.tourService.menuToggleRequest.subscribe(() => {
      if (!this.menuOpen) this.toggleMainMenu();
    });

    this.modelChangeSub = this.tourService.currentStep$.subscribe(step => {
      this.isTourActive = step !== null;
    });

    this.menuStateSubscription = this.sideMenusService.mainMenuOpen$.subscribe(isOpen => {
      this.menuOpen = isOpen;
    });

    this.modelNameSub = this.modelSelectionService.selectedModelName$.subscribe(modelName => {
      if (modelName !== this.selectedModelName) {
        this.selectedModelName = modelName;
        this.updateModelNameLetters();
        this.updateBrandLettersForModelName();
        this.cdr.detectChanges();
      }
    });

    const serviceModelName = this.modelSelectionService.getSelectedModelName();
    if (serviceModelName) {
      this.selectedModelName = serviceModelName;
      this.updateModelNameLetters();
      this.updateBrandLettersForModelName();
      if (!localStorage.getItem('selectedModelName')) {
        localStorage.setItem('selectedModelName', serviceModelName);
      }
    } else {
      this.subscribeToModelChanges();
    }

    this.handleToolsMenuOpen = () => {
      this.showToolsMenu = true;
      this.cdr.detectChanges();
    };
    window.addEventListener('clarichatOpenToolsMenu', this.handleToolsMenuOpen);

    this.updateModelNameLetters();
    this.updateBrandLettersForModelName();
    this.readTopnavFlags();
    this.loadCompareModelNames();

    this.compareModelsChangedListener = ((event: CustomEvent) => {
      this.compareLeftName = event.detail?.left || '';
      this.compareRightName = event.detail?.right || '';
      this.updateCompareLetters();
      this.cdr.detectChanges();
    }) as EventListener;

    window.addEventListener('compareModelsChanged', this.compareModelsChangedListener);
    this.updateNavCollapseState(this.router.url);
  }

  ngOnDestroy(): void {
    this.tourSub?.unsubscribe();
    this.loginStateSub?.unsubscribe();
    this.logoutSub?.unsubscribe();
    this.modelChangeSub?.unsubscribe();
    this.menuStateSubscription?.unsubscribe();
    this.modelNameSub?.unsubscribe();

    if (this.modelStoragePollInterval) {
      clearInterval(this.modelStoragePollInterval);
    }
    if (this.handleModelChange) {
      window.removeEventListener('selectedModelChanged', this.handleModelChange as EventListener);
    }

    if (this.handleToolsMenuOpen) {
      window.removeEventListener('clarichatOpenToolsMenu', this.handleToolsMenuOpen);
    }

    if (this.compareModelsChangedListener) {
      window.removeEventListener('compareModelsChanged', this.compareModelsChangedListener);
    }
  }

  toggleNavCollapse(): void {
    this.isNavCollapsed = !this.isNavCollapsed;
    localStorage.setItem('navCollapsed', String(this.isNavCollapsed));
  }

  getClariLetterColor(index: number): string {
    const ratio = this.brandLetters.length > 1
      ? 1 - index / (this.brandLetters.length - 1)
      : 0;
    const r = Math.round(this.clariBaseColor.r + (255 - this.clariBaseColor.r) * ratio);
    const g = Math.round(this.clariBaseColor.g + (255 - this.clariBaseColor.g) * ratio);
    const b = Math.round(this.clariBaseColor.b + (255 - this.clariBaseColor.b) * ratio);
    return `rgb(${r}, ${g}, ${b})`;
  }

  getClariLetterTransitionColor(index: number): string {
    const baseRatio = this.brandLetters.length > 1
      ? 1 - index / (this.brandLetters.length - 1)
      : 0;
    const ratio = Math.min(1, baseRatio + 0.12);
    const r = Math.round(this.clariBaseColor.r + (255 - this.clariBaseColor.r) * ratio);
    const g = Math.round(this.clariBaseColor.g + (255 - this.clariBaseColor.g) * ratio);
    const b = Math.round(this.clariBaseColor.b + (255 - this.clariBaseColor.b) * ratio);
    return `rgb(${r}, ${g}, ${b})`;
  }

  getClariLetterDelay(index: number): string {
    return `${index * 0.08}s`;
  }

  getChatLetterColor(index: number): string {
    const darkenAmount = index * this.chatDarkenStep;
    const r = Math.max(0, this.chatBaseColor.r - darkenAmount);
    const g = Math.max(0, this.chatBaseColor.g - darkenAmount);
    const b = Math.max(0, this.chatBaseColor.b - darkenAmount);
    return `rgb(${r}, ${g}, ${b})`;
  }

  getModelNameLetterColor(index: number): string {
    const reversedIndex = (this.modelNameLetters.length - 1) - index;
    const lightenAmount = reversedIndex * this.chatDarkenStep;
    const r = Math.min(255, this.chatBaseColor.r + lightenAmount);
    const g = Math.min(255, this.chatBaseColor.g + lightenAmount);
    const b = Math.min(255, this.chatBaseColor.b + lightenAmount);
    return `rgb(${r}, ${g}, ${b})`;
  }

  getModelNameLetterDelay(index: number): string {
    return `${index * 0.08}s`;
  }

  isModelNameSpacer(letter: string): boolean {
    return letter === '' || letter === ' ' || letter === this.modelNameWordSeparator;
  }

  private buildModelNameLetters(modelName: string): string[] {
    const trimmed = modelName.trim();
    if (!trimmed) {
      return [];
    }

    const letters: string[] = [];
    let lastNonSpaceChar = '';

    for (let i = 0; i < trimmed.length; i += 1) {
      const char = trimmed[i];

      if (/\s/.test(char)) {
        if (letters.length > 0 && letters[letters.length - 1] !== this.modelNameWordSeparator) {
          letters.push(this.modelNameWordSeparator);
        }
        lastNonSpaceChar = '';
        continue;
      }

      if (lastNonSpaceChar && this.isModelWordBoundary(lastNonSpaceChar, char, trimmed[i + 1])) {
        letters.push(this.modelNameWordSeparator);
      }

      letters.push(char);
      lastNonSpaceChar = char;
    }

    return letters;
  }

  private isModelWordBoundary(prev: string, current: string, next?: string): boolean {
    const isPrevLower = /[a-z]/.test(prev);
    const isPrevUpper = /[A-Z]/.test(prev);
    const isPrevLetter = /[A-Za-z]/.test(prev);
    const isPrevDigit = /[0-9]/.test(prev);
    const isCurrentUpper = /[A-Z]/.test(current);
    const isCurrentLetter = /[A-Za-z]/.test(current);
    const isCurrentDigit = /[0-9]/.test(current);
    const isNextLower = next ? /[a-z]/.test(next) : false;

    if (isPrevLower && isCurrentUpper) {
      return true;
    }

    if (isPrevLetter && isCurrentDigit) {
      return true;
    }

    if (isPrevDigit && isCurrentLetter) {
      return true;
    }

    if (isPrevUpper && isCurrentUpper && isNextLower) {
      return true;
    }

    return false;
  }

  updateModelNameLetters(): void {
    if (this.selectedModelName) {
      this.modelNameLetters = this.buildModelNameLetters(this.selectedModelName);
    } else {
      this.modelNameLetters = [];
    }
  }

  private updateCompareLetters(): void {
    this.compareLeftLetters = this.buildModelNameLetters(this.compareLeftName || '');
    this.compareRightLetters = this.buildModelNameLetters(this.compareRightName || '');
  }

  getCompareLeftLetterColor(index: number): string {
    const reversedIndex = (this.compareLeftLetters.length - 1) - index;
    const lightenAmount = reversedIndex * this.chatDarkenStep;
    const r = Math.min(255, this.chatBaseColor.r + lightenAmount);
    const g = Math.min(255, this.chatBaseColor.g + lightenAmount);
    const b = Math.min(255, this.chatBaseColor.b + lightenAmount);
    return `rgb(${r}, ${g}, ${b})`;
  }

  getCompareRightLetterColor(index: number): string {
    const reversedIndex = (this.compareRightLetters.length - 1) - index;
    const lightenAmount = reversedIndex * this.chatDarkenStep;
    const r = Math.min(255, this.chatBaseColor.r + lightenAmount);
    const g = Math.min(255, this.chatBaseColor.g + lightenAmount);
    const b = Math.min(255, this.chatBaseColor.b + lightenAmount);
    return `rgb(${r}, ${g}, ${b})`;
  }

  openAiCatalog(): void {
    const modelId = this.currentModelId || localStorage.getItem('lastSelectedModel') || '';
    const modelName = this.selectedModelName || localStorage.getItem('selectedModelName') || '';
    this.dialog.open(AiCatalogComponent, {
      panelClass: 'ai-catalog-dialog-panel',
      width: '900px',
      maxWidth: '98vw',
      height: 'auto',
      maxHeight: '95vh',
      data: {
        selectedModel: modelId,
        selectedModelName: modelName
      }
    });
  }

  openCompareModelBio(side: 'left' | 'right', ev: MouseEvent): void {
    ev.stopPropagation();
    window.dispatchEvent(new CustomEvent('openCompareModelBio', { detail: { side } }));
  }

  openCompareModelSelector(): void {
    window.dispatchEvent(new CustomEvent('openCompareModelSelector'));
  }

  toggleToolsMenu(): void {
    this.showToolsMenu = !this.showToolsMenu;
  }

  closeToolsMenu(): void {
    this.showToolsMenu = false;
  }

  openModelSpecDialogFromTools(): void {
    this.openModelSpecDialog();
    this.closeToolsMenu();
  }

  openAICatalogFromTools(): void {
    this.openAiCatalog();
    this.closeToolsMenu();
  }

  openAdvisoryFromTools(): void {
    this.sideMenusService.openAdvisory();
    this.closeToolsMenu();
  }

  triggerRepeatPrompt(): void {
    window.dispatchEvent(new CustomEvent('clarichatRepeatPrompt'));
    this.closeToolsMenu();
  }

  triggerExportPdf(): void {
    window.dispatchEvent(new CustomEvent('clarichatExportPdf'));
    this.closeToolsMenu();
  }

  triggerExportDocx(): void {
    window.dispatchEvent(new CustomEvent('clarichatExportDocx'));
    this.closeToolsMenu();
  }

  triggerStartTour(): void {
    window.dispatchEvent(new CustomEvent('clarichatStartTour'));
    this.closeToolsMenu();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.settingsMenuOpen) {
      if (!this.profileMenuRef?.nativeElement) return;
      const clickedInside = this.profileMenuRef.nativeElement.contains(event.target as any);
      if (!clickedInside) {
        this.settingsMenuOpen = false;
      }
    }

    if (this.showToolsMenu) {
      const target = event.target as HTMLElement;
      const clickedInsideTools =
        this.clarichatToolsMenuContainer?.nativeElement?.contains(target) ?? false;
      if (!clickedInsideTools) {
        this.closeToolsMenu();
      }
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.isScrolled = offset > 10;
  }

  startTour(): void {
    this.settingsMenuOpen = false;
    this.runTour(true);
  }

logout(event?: Event): void {
  event?.preventDefault();
  event?.stopPropagation();

  this.logoutSub?.unsubscribe();
  this.logoutSub = this.chatFireService.logout().subscribe({
    next: () => {
      this.settingsMenuOpen = false;
      this.isLoggedIn = false;
      this.router.navigate(['/auth/log-in'], {
        queryParams: { loggedOut: 'true' }
      });
    },
    error: (error) => {
      console.error('[TopNavbarComponent] logout failed', error);
      this.settingsMenuOpen = false;
      this.isLoggedIn = false;
      this.router.navigate(['/auth/log-in'], {
        queryParams: { loggedOut: 'true' }
      });
    }
  });
}

  goToClariChat(): void {
    this.router.navigate(['/ai/clarity']);
  }

  goToDualChat(): void {
    this.router.navigate(['/ai/compare-mode']);
  }

  goToImageTeam(): void {
    this.router.navigate(['/iq/image-team']);
  }

  openClariMedia(): void {
    this.router.navigate(['/ai/clari-media']);
  }

  openClariTeam(): void {
    this.router.navigate(['/iq/team-ai']);
  }

  toggleMainMenu(): void {
    this.sideMenusService.toggleMainMenuSubject.next('toggle');
  }

  toggleAltMenu(): void {
    this.sideMenusService.toggleAltMenuSubject.next('toggle');
  }

  toggleSettingsMenu(): void {
    this.settingsMenuOpen = !this.settingsMenuOpen;
  }

  toggleNotificationsMenu(): void {
    this.toggleAltMenu();
  }

  private buildTourSteps(): TourStep[] {
    return [
      { elementId: 'brandingClariChat', title: '<span class="first-line">The Future Awaits</span>', description: '<span class="line-beige">One Prompt</span><br><span class="line-beige">Competitive Accuracy</span><br><span class="line-beige">1-6 Scored Answers</span><br><span class="line-beige">Always Context</span><br><span class="line-beige">The Best AI Access</span><br><span class="line-beige last-line">The AI Democracy</span>' },
      { elementId: 'previousPromptsBtn', title: 'My Prompts', description: 'Your best prompts live here. Reuse them instantly.' },
      { elementId: 'modelSpecsSection', title: 'Bio', description: 'Tap this — it reveals what your AI is REALLY capable of.' },
      { elementId: 'aiCatalogBtn', title: 'AI Models', description: 'This is where the real advantage lives — the right model can deliver 10× better results.' },
      { elementId: 'modelSpecsSection', title: 'Bio', description: 'Tap this — it reveals what your AI is REALLY capable of.' },
      { elementId: 'moreSection', title: 'More Section', description: 'Hidden power tools inside. You’re gonna want this.' },
      { elementId: 'chatInputTextarea', title: 'Your Text Area', description: 'Drop your idea here — we’ll turn it into something unreal.' },
      { elementId: 'sendMessageButton', title: 'Send Button', description: 'Hit send and watch the AI come alive.' },
      { elementId: 'attachImageButton', title: 'Attach Image', description: 'Upload a photo — the AI will dissect it like a pro.' },
      { elementId: 'micButton', title: 'Voice Input', description: 'Talk instead of type. It feels futuristic.' },
      { elementId: 'advisorFab', title: 'Advisor Button', description: 'This floating Advisor button opens your Coach menu. You can drag it anywhere on the screen, and it stays accessible while you work.' },
      { elementId: 'placeholderNavArrows', title: 'Choose a Model', description: 'Preview a few featured models here. Open the AI Selector to access many more.' },
      { elementId: 'profileMenuSection', title: 'Your Profile', description: 'Your command center — settings, upgrades, everything.' },
      { elementId: 'loginLink', title: 'Log In', description: 'Log in to unlock the full ClariChat experience.' },
      { elementId: 'aiExecsLink', title: 'GroupChat', description: 'Ask once. Get answers from multiple AIs. Instant advantage.' },
      { elementId: 'menuToggleBtn', title: 'Side Menu', description: 'Open this — the real power features are in here.', openMenu: true },
      { elementId: 'claritools', title: 'Clarity ToolKit', description: 'This is your cheat code. Don’t skip it.' },
    ];
  }

  private runTour(showAlertIfNotAllowed: boolean = false): void {
    const tourRoutes = ['/ai/clarity', '/ai/clari-sandbox'];
    const isAllowed = tourRoutes.some(route => this.router.url.includes(route));
    if (!isAllowed) {
      if (showAlertIfNotAllowed) {
        alert('Click on ClariChat at the top left of the page to enable the Tour.');
      }
      return;
    }

    this.tourService.startTour(this.buildTourSteps());
  }

  private syncCurrentModelId(): void {
    this.currentModelId =
      this.route.snapshot.queryParams['model'] ||
      localStorage.getItem('lastSelectedModel') ||
      '';
  }

  private loadCompareModelNames(): void {
    this.compareLeftName = localStorage.getItem('compareLeftModelName') || '';
    this.compareRightName = localStorage.getItem('compareRightModelName') || '';
    this.updateCompareLetters();
  }

  toggleTempChat(): void {
    this.isTempChatActive = !this.isTempChatActive;
    localStorage.setItem('tempChatActive', String(this.isTempChatActive));
    window.dispatchEvent(new CustomEvent('tempChatToggled', { detail: { active: this.isTempChatActive } }));
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  private readTopnavFlags(): void {
    const active = this.getDeepestChild(this.route);
    this.showModelName = !!active.snapshot.data?.['showModelName'];
    this.showModelName2 = !!active.snapshot.data?.['showModelName2'];
  }

  private updateRouteFlags(url: string): void {
    this.isInDoubleSandbox = url.includes('/ai/compare-mode');
    this.isInClarityChat = url.includes('/ai/clarity');
    this.isInClariAuth = url.includes('/auth/log-in') || url.includes('/auth/log-in');
    this.isInClarityVideoChat = url.includes('/ai/clari-studio');
    this.isOnClariVideoRoute = url.includes('/clari-video-chat');
    this.isOnCompareModeRoute = url.includes('/ai/double-chat');
    this.isOnClariChatRoute =
      url.includes('/ai/clarity') || url.includes('/ai/clarichat');
    this.isOnCloneRoute = url.includes('/ai/clone');
    this.isOnParallaxChatRoute = url.includes('/multi-ai/parallax-chat');
    this.isOnMultiChatRoute =
      url.includes('/multi-ai/executive-chat') || url.includes('/multi-ai/exective-chat');
    if (!this.isOnClariChatRoute && !this.isOnCloneRoute) {
      this.closeToolsMenu();
    }
    this.updateBrandLetters(url);
    this.updateNavCollapseState(url);
  }

  private updateBrandLetters(url: string): void {
    if (url.includes('/multi-ai/parallax-chat')) {
      this.brandLetters = [...this.parallaxLetters];
      return;
    }
    if (url.includes('/ai/compare-mode')) {
      this.brandLetters = [];
      return;
    }
    if (url.includes('/multi-ai/exective-chat') || url.includes('/exective-chat')) {
      this.brandLetters = [...this.executiveLetters];
      return;
    }
    this.brandLetters = [...this.clariLetters];
  }

  /**
   * Collapse the top toolbar on every route except main ClariChat so other pages get more vertical space.
   * On ClariChat only, respect the user's toggle preference in localStorage.
   */
  private updateNavCollapseState(url: string): void {
    const isClariChatRoute =
      url.includes('/ai/clarity') || url.includes('/ai/clarichat');
    if (isClariChatRoute) {
      this.isNavCollapsed = false;
      localStorage.setItem('navCollapsed', 'false');
      return;
    }
    this.isNavCollapsed = true;
  }

  private subscribeToModelChanges(): void {
    const storedModelName = localStorage.getItem('selectedModelName');
    if (storedModelName) {
      this.selectedModelName = storedModelName;
      this.updateModelNameLetters();
      this.updateBrandLettersForModelName();
    } else {
      const modelId = localStorage.getItem('lastSelectedModel');
      if (modelId) {
        this.selectedModelName = this.getModelNameFromId(modelId);
        this.updateModelNameLetters();
        this.updateBrandLettersForModelName();
      } else {
        this.selectedModelName = 'ChatGPT 5.4';
        this.updateModelNameLetters();
        this.updateBrandLettersForModelName();
        localStorage.setItem('selectedModelName', this.selectedModelName);
      }
    }

    this.handleModelChange = (event: CustomEvent) => {
      if (event.detail?.modelName) {
        this.selectedModelName = event.detail.modelName;
        this.updateModelNameLetters();
        this.updateBrandLettersForModelName();
      }
    };
    window.addEventListener('selectedModelChanged', this.handleModelChange as EventListener);

    this.modelStoragePollInterval = setInterval(() => {
      const currentModelName = localStorage.getItem('selectedModelName');
      if (currentModelName && currentModelName !== this.selectedModelName) {
        this.selectedModelName = currentModelName;
        this.updateModelNameLetters();
        this.updateBrandLettersForModelName();
        this.cdr.detectChanges();
      } else if (!currentModelName) {
        const modelId = localStorage.getItem('lastSelectedModel');
        if (modelId) {
          const name = this.getModelNameFromId(modelId);
          if (name && name !== this.selectedModelName) {
            this.selectedModelName = name;
            this.updateModelNameLetters();
            this.updateBrandLettersForModelName();
            this.cdr.detectChanges();
          }
        }
      }
    }, 500);
  }

  openModelSpecDialog(): void {
    window.dispatchEvent(new CustomEvent('openModelSpecDialog'));
  }

  openAICatalog(): void {
    window.dispatchEvent(new CustomEvent('openAICatalog'));
  }

  private getModelNameFromId(modelId: string): string {
    const modelMap: { [key: string]: string } = {
      'chatgpt5': 'ChatGPT 5.2',
      'opus45': 'Claude Opus 4.5',
      'opus46': 'Claude Opus 4.6',
      'opus47': 'Claude Opus 4.7',
      'opus6': 'Claude Opus 4.6',
      'kimik25': 'Kimi 2.5',
      'qwen': 'Qwen 3 Coder',
      'opus': 'Claude Opus 4',
      'zai': 'GLM 4.7',
      'palmx': 'Palmyra X5',
      'gemini': 'Gemini Pro',
      'grok': 'Grok',
      'chatgpt5-mini': 'ChatGPT 5-mini',
      'pixtralimage': 'Pixtral',
      'deepv3': 'DeepSeek V3.2',
      'chatgpt54': 'ChatGPT 5.4',
      'minichatgpt54': 'ChatGPT Mini',
      'codestralto': 'Codestral',
      'maverick': 'Llama 4',
      'o3': 'ChatGPT o3',
      'deepseek': 'Deepseek R1',
      'cohere': 'Cohere R+',
      'chatgpt': 'ChatGPT 5.2',
      'chatgpt41': 'ChatGPT 4.1',
      'claude4': 'Sonnet 4',
      'sonnet45': 'Sonnet 4.5',
      'sonnet4': 'Sonnet 4',
      'haiku45': 'Claude Haiku 4.5',
      'haiku': 'Claude Haiku 4.5',
      'premier': 'Nova Premier',
      'jamba': 'Jamba',
      'mistrallarge': 'Mistral Large',
      'llama': 'Llama 3.3 70B',
      'scout': 'Scout'
    };
    return modelMap[modelId] || 'Select a Model';
  }

  private updateBrandLettersForModelName(): void {
    if (!this.isOnClariChatRoute) {
      return;
    }
    this.brandLetters = [...this.clariLetters];
  }
}
